<template>
	<div style="background-color: #eee">
		<v-overlay :value="isLoading || isLoadingChanges">
			<v-progress-circular
				indeterminate
				size="64"
				color="primary"
			></v-progress-circular>
		</v-overlay>

		<div
			v-if="!isLoading"
			style="background-color: #eee"
		>
			<div class="_box_title">
				Il tuo profilo cliccatore
			</div>
			<div
				class="d-flex justify-space-between pa-3 mb-6"
				style="background-color: white"
			>
				<div class="mx-3 font-weight-medium">
					<div>Codice Cliccatore</div>
					<div :style="`color: ${scdColor}`">{{ codiceCliccatore }}</div>
				</div>
				<div class="mr-3 font-weight-medium">
					<div>Username</div>
					<div :style="`color: ${scdColor}`">{{ usernameCliccatore }}</div>
				</div>
				<div class="mr-3 font-weight-medium">
					<div>Squadra</div>
					<div :style="`color: ${scdColor}`">{{ nomeSquadra }}</div>
				</div>
				<div class="mr-3 font-weight-medium">
					<div class="font-weight-bold" style="background-color: #bfd0ea; padding: 5px 15px;">Storico Click Day</div>
					<table style="width: 100%; font-size: 14px; background-color: #e3ebf6; padding: 5px 15px;">
						<tr>
							<td>Partecipati</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ clickdayPartecipati }}</span></td>
						</tr>
						<tr>
							<td>Vinti</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ clickdayVinti }}</span></td>
						</tr>
						<tr>
							<td>Persi</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ clickdayPersi }}</span></td>
						</tr>
						<tr>
							<td>Abbandonati</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ clickdayAbbandonati }}</span></td>
						</tr>
						<tr>
							<td>Non assegnati</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ clickdayNonAssegnati }}</span></td>
						</tr>
					</table>
				</div>
				<div class="mr-3 font-weight-medium">
					<div class="font-weight-bold" style="background-color: #bfd0ea; padding: 5px 15px;">Storico Game Day</div>
					<table style="width: 100%; font-size: 14px; background-color: #e3ebf6; padding: 5px 15px;">
						<tr>
							<td>Partecipati</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ gamedayPartecipati }}</span></td>
						</tr>
						<tr>
							<td>Vinti</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ gamedayVinti }}</span></td>
						</tr>
						<tr>
							<td>Persi</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ gamedayPersi }}</span></td>
						</tr>
						<tr>
							<td>Abbandonati</td>
							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ gamedayAbbandonati }}</span></td>
						</tr>
					</table>
				</div>
				<div class="font-weight-medium mr-3" style="min-width: 114px">
					<div class="font-weight-bold text-center" style="background-color: #e7ab51; padding: 5px 15px;">Classifica</div>
					<table style="width: 100%; font-size: 14px; background-color: #ececd0; padding: 5px 15px;">
						<tr>
							<td>Punti</td>
							<td>
								<v-progress-circular
									v-if="isLoadingDatiClassificaCliccatore"
									size="14"
									width="1"
									indeterminate
									class="ml-6"
									:color="scdColorStrong"
								></v-progress-circular>
								<span
									v-else
									class="font-weight-bold pl-6"
									:style="`color: ${scdColorStrong}`"
								>
									{{ puntiClassifica || '-'}}
								</span>
							</td>
						</tr>
						<tr>
							<td>Posizione</td>
							<td>
								<v-progress-circular
									v-if="isLoadingDatiClassificaCliccatore"
									size="14"
									width="1"
									indeterminate
									class="ml-6"
									:color="scdColorStrong"
								></v-progress-circular>
								<template v-else>
									<span class="font-weight-bold pl-6" :style="`color: ${scdColorStrong}`">{{ posizioneClassifica || '-' }}</span>
									<span v-if="posizioneClassifica != null" class="font-weight-bold" :style="`color: ${scdColorStrong}`">°</span>
								</template>
							</td>
						</tr>
						<tr>
							<td style="height: 21px"></td>
						</tr>
					</table>
				</div>
			</div>
			
			<div class="_box_title">
				Click Day Attivo
			</div>
			<click-day-box-component
				:key="clickDayBoxKey"
				:value="datiProfiloCliccatore"
				:is-loading-profilo="isLoadingProfilo"
				:id-cliccatore="idCliccatore"
				@dati-esito-clickday-aggiornati="aggiornaDashboard()"
				@salvataggio-dati-di-fatturazione-eseguito="aggiornaDashboard()"
				@cliccatore-iscritto="aggiornaDashboard()"
			></click-day-box-component>
			
			<!--<div class="_box_title">-->
			<!--	Click Day Attivo-->
			<!--</div>-->
			<!--<div-->
			<!--	style="background-color: white"-->
			<!--	class="pa-3 mb-6"-->
			<!--&gt;-->
			<!--	<v-row class="justify-space-between">-->
			<!--		<v-col cols="8" class="d-flex flex-column">-->
			<!--			<div class="d-flex justify-space-between mb-8 mx-3">-->
			<!--				<div class="mb-6 mr-6" style="font-size: 14px;">-->
			<!--					<div class="font-weight-bold" style="font-size: 18px">{{ nomeBando }}</div>-->
			<!--					<div class="font-weight-medium">Data Click Day:-->
			<!--						<span :style="`color:${scdColor};`">{{ computedDateTimeWithoutSeconds(dataOraClickDay) || 'Data non disponibile' }}</span>-->
			<!--					</div>-->
			<!--				</div>-->
			<!--				-->
			<!--				<div style="font-size: 14px;">-->
			<!--					<div class="font-weight-medium">Compenso base per vittoria:-->
			<!--						<span :style="`color:${scdColor};`">{{ compensoVittoria }}€</span>-->
			<!--					</div>-->
			<!--					<div class="font-weight-medium">Punti in classifica per vittoria:-->
			<!--						<span :style="`color:${scdColor};`">{{ puntiClickdayVinto }}</span>-->
			<!--					</div>-->
			<!--					<div class="font-weight-medium">Punti in classifica per perdita:-->
			<!--						<span :style="`color:${scdColor};`">{{ puntiClickdayPerso }}</span>-->
			<!--					</div>-->
			<!--				</div>-->
			<!--				-->
			<!--				<div class="mr-3 font-weight-medium">-->
			<!--					<div class="font-weight-bold" style="background-color: #bfd0ea; padding: 5px 15px;">Game Day del Bando</div>-->
			<!--					<table style="width: 100%; font-size: 14px; background-color: #e3ebf6; padding: 5px 15px;">-->
			<!--						<tr>-->
			<!--							<td>Partecipati</td>-->
			<!--							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ gamedayPartecipatiBandoAttuale }}</span></td>-->
			<!--						</tr>-->
			<!--						<tr>-->
			<!--							<td>Vinti</td>-->
			<!--							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ gamedayVintiBandoAttuale }}</span></td>-->
			<!--						</tr>-->
			<!--						<tr>-->
			<!--							<td>Persi</td>-->
			<!--							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ gamedayPersiBandoAttuale }}</span></td>-->
			<!--						</tr>-->
			<!--						<tr>-->
			<!--							<td>Abbandonati</td>-->
			<!--							<td><span class="font-weight-bold" :style="`color: ${scdColorStrong}`">{{ gamedayAbbandonatiBandoAttuale }}</span></td>-->
			<!--						</tr>-->
			<!--					</table>-->
			<!--				</div>-->
			<!--			</div>-->
			
			<!--			&lt;!&ndash;<div class="d-flex align-center  mb-6">&ndash;&gt;-->
			<!--			<div class="d-flex align-center mb-6 ml-3">-->
			<!--				<div class="_box-profilo-cliccatore">-->
			<!--					<div>Simulazioni eseguite</div>-->
			<!--					<v-progress-circular v-if="isLoadingProfilo" class="mt-2" size="14" width="1" indeterminate :color="scdColor"></v-progress-circular>-->
			<!--					<span v-else :style="`color:${scdColor}`">{{ simulazioniTotali }}</span>-->
			<!--				</div>-->
			<!--				<div class="_box-profilo-cliccatore">-->
			<!--					<div>Win Score attuale</div>-->
			<!--					<v-progress-circular v-if="isLoadingProfilo" class="mt-2" size="14" width="1" indeterminate :color="scdColor"></v-progress-circular>-->
			<!--					<template v-else>-->
			<!--						<span :style="`color:${scdColor}`">{{ punteggioAttuale }}</span>-->
			<!--						<small v-if="!almenoXSimulazioni">(mancano ancora {{ simulazioniMancanti }} simulazioni)</small>-->
			<!--					</template>-->
			<!--				</div>-->
			<!--				<div class="_box-profilo-cliccatore">-->
			<!--					<div>Win Score migliore</div>-->
			<!--					<v-progress-circular v-if="isLoadingProfilo" class="mt-2" size="14" width="1" indeterminate :color="scdColor"></v-progress-circular>-->
			<!--					<template v-else>-->
			<!--						<span :style="`color:${scdColor}`">{{ migliorPunteggioString }}</span>-->
			<!--						<small v-if="!almenoXSimulazioni">(mancano ancora {{ simulazioniMancanti }} simulazioni)</small>-->
			<!--					</template>-->
			<!--				</div>-->
			<!--				<div class="_box-profilo-cliccatore">-->
			<!--					<div class="d-flex">-->
			<!--						<div class="mr-2">Stato selezione</div>-->
			<!--						<v-tooltip bottom :color="scdColor">-->
			<!--							<template v-slot:activator="{ on }">-->
			<!--								<v-icon :color="scdColor" small dark v-on="on">info</v-icon>-->
			<!--							</template>-->
			<!--							<span>Per superare la selezione devi aver raggiunto almeno una volta {{ minimoWinScoreSelezione.toString()[0] == '8' ? "l'" : 'il' }} {{ minimoWinScoreSelezione }}% di simulazioni vinte nelle ultime {{ minimoSimulazioniSelezione }}</span>-->
			<!--						</v-tooltip>-->
			<!--					</div>-->
			<!--					<v-progress-circular v-if="isLoadingProfilo" class="mt-2" size="14" width="1" indeterminate :color="scdColor"></v-progress-circular>-->
			<!--					<template v-else>-->
			<!--						<small v-if="!almenoXSimulazioni">(mancano ancora {{ simulazioniMancanti }} simulazioni)</small>-->
			<!--						<span v-else :style="`color:${scdColor}`">{{ selezioneSuperata ? 'Superata' : 'Non superata' }}</span>-->
			<!--					</template>-->
			<!--				</div>-->
			<!--			</div>-->
			<!--			&lt;!&ndash;</div>&ndash;&gt;-->
			
			<!--			<v-simple-table>-->
			<!--				<template v-slot:default>-->
			<!--					<thead>-->
			<!--					<tr>-->
			<!--						<th class="text-left"></th>-->
			<!--						<th class="text-left">-->
			<!--							Base-->
			<!--						</th>-->
			<!--						<th-->
			<!--							v-if="compensoSelezione !== null"-->
			<!--							class="text-left"-->
			<!--						>-->
			<!--							Selezione-->
			<!--						</th>-->
			<!--						<th class="text-left">-->
			<!--							Game Day-->
			<!--						</th>-->
			<!--						<th class="text-left">-->
			<!--							Vittorie degli amici-->
			<!--						</th>-->
			<!--						<th class="text-left" style="background-color: #e2eaf5">-->
			<!--							TOTALE-->
			<!--						</th>-->
			<!--					</tr>-->
			<!--					</thead>-->
			<!--					<tbody>-->
			<!--					<tr>-->
			<!--						<td class="font-weight-medium">Compenso in caso di vittoria</td>-->
			<!--						<td class="font-weight-medium" :style="`color:${scdColor};`">{{ compensoVittoria }}€</td>-->
			<!--						<td-->
			<!--							v-if="compensoSelezione !== null"-->
			<!--							class="font-weight-medium"-->
			<!--							:style="`color:${scdColor};`"-->
			<!--						>-->
			<!--							{{ selezioneSuperata ? compensoSelezione : 0 }}€-->
			<!--						</td>-->
			<!--						<td class="font-weight-medium" :style="`color:${scdColor};`">-->
			<!--							<span v-if="gamedaysAbilitati">{{ sommaCompensiGamedaysVintiEPersiClickdayVinto }}€</span>-->
			<!--							<span v-else>-</span>-->
			<!--						</td>-->
			<!--						<td class="font-weight-medium" :style="`color:${scdColor};`">-->
			<!--							<span v-if="bonusVittorieAmiciAbilitati">{{ sommaCompensiPerAmiciVincentiEsitiDefinitivi }}€</span>-->
			<!--							<span v-else>-</span>-->
			<!--						</td>-->
			<!--						<td class="font-weight-medium" :style="`color:${scdColor}; background-color: #e2eaf5;`">{{ totaleCompensoVittoriaEsitiDefinitivi }}€</td>-->
			<!--					</tr>-->
			<!--					<tr>-->
			<!--						<td class="font-weight-medium">Compenso in caso di perdita/non assegnato</td>-->
			<!--						<td class="font-weight-medium" :style="`color:${scdColor};`">{{ compensoPerdita }}€</td>-->
			<!--						<td-->
			<!--							v-if="compensoSelezione !== null"-->
			<!--							class="font-weight-medium"-->
			<!--							:style="`color:${scdColor};`"-->
			<!--						>-->
			<!--							{{ selezioneSuperata ? compensoSelezione : 0 }}€-->
			<!--						</td>-->
			<!--						<td class="font-weight-medium" :style="`color:${scdColor};`">-->
			<!--							<span v-if="gamedaysAbilitati">{{ sommaCompensiGamedaysVintiEPersiClickdayPerso }}€</span>-->
			<!--							<span v-else>-</span>-->
			<!--						</td>-->
			<!--						<td class="font-weight-medium" :style="`color:${scdColor};`">-->
			<!--							<span v-if="bonusVittorieAmiciAbilitati">{{ sommaCompensiPerAmiciVincentiEsitiDefinitivi }}€</span>-->
			<!--							<span v-else>-</span>-->
			<!--						</td>-->
			<!--						<td class="font-weight-medium" :style="`color:${scdColor}; background-color: #e2eaf5;`">{{ totaleCompensoPerditaEsitiDefinitivi }}€</td>-->
			<!--					</tr>-->
			<!--					</tbody>-->
			<!--				</template>-->
			<!--			</v-simple-table>-->
			<!--		</v-col>-->
			
			<!--		&lt;!&ndash;max-width:259px&ndash;&gt;-->
			<!--		<v-col cols="4">-->
			<!--			<div class="d-flex flex-column scatola-azzurra mb-4">-->
			<!--				<div class="d-flex align-center">-->
			<!--					&lt;!&ndash;<v-skeleton-loader class="skeleton_loader_esito_clickday mb-2" v-if="isLoadingProfilo" type="avatar"></v-skeleton-loader>&ndash;&gt;-->
			<!--					&lt;!&ndash;<v-img class="mb-2" v-else-if="!isLoadingProfilo" :src="urlImmagineEsitoClickday" max-height="80" contain></v-img>&ndash;&gt;-->
			<!--					<div v-if="!isLoadingProfilo" style="font-weight:700; font-size:20px;" class="flex-grow-1">-->
			<!--						<v-row v-if="!iscrittoAlClickdayAttuale" :style="`color: ${scdColorDarkBlue}`" class="align-center no-gutters">-->
			<!--							<v-col cols="1" class="mr-3"><v-icon class="icon-outlined" size="20" :color="scdColorDarkBlue">mdi-account-minus-outline</v-icon></v-col>-->
			<!--							<v-col><div>Non sei iscritto a questo Click Day</div></v-col>-->
			<!--						</v-row>-->
			<!--						<v-row v-else-if="esitoClickday === 'Iscritto'" :style="`color:${scdOrange};`" class="align-center no-gutters">-->
			<!--							<v-col cols="1" class="mr-3"><v-icon class="icon-outlined" :style="`border-color: ${scdOrange}`" size="20" :color="scdOrange">mdi-account-plus-outline</v-icon></v-col>-->
			<!--							<v-col><div>Sei iscritto a questo Click Day</div></v-col>-->
			<!--						</v-row>-->
			<!--						<v-row v-else-if="esitoClickday === 'In attesa di esito'" :style="`color:${scdColorDarkBlue};`" class="align-center no-gutters">-->
			<!--							<v-col cols="1" class="mr-3">-->
			<!--								<v-icon class="icon-outlined" size="20" :color="scdColorDarkBlue">hourglass_bottom</v-icon>-->
			<!--							</v-col>-->
			<!--							<v-col><div>In attesa di esito</div></v-col>-->
			<!--						</v-row>-->
			<!--						<v-row v-else-if="esitoClickday === 'Vincente' || esitoClickday === 'Vincente Esiti Definitivi'" :style="`color:${scdGreen};`" class="align-center no-gutters">-->
			<!--							<v-col cols="1" class="mr-3">-->
			<!--								<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdGreen}`" :color="scdGreen">mdi-trophy-variant-outline</v-icon>-->
			<!--							</v-col>-->
			<!--							<v-col><div>Hai vinto!</div></v-col>-->
			<!--						</v-row>-->
			<!--						<v-row v-else-if="esitoClickday === 'Non assegnato'" :style="`color:${scdGreen};`" class="align-center no-gutters">-->
			<!--							<v-col cols="1" class="mr-3">-->
			<!--								<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdGreen}`" :color="scdGreen">military_tech</v-icon>-->
			<!--							</v-col>-->
			<!--							<v-col><div>Click non assegnato</div></v-col>-->
			<!--						</v-row>-->
			<!--						<v-row v-else-if="esitoClickday === 'Non vincente'" :style="`color:${scdLightRed};`" class="align-center no-gutters">-->
			<!--							<v-col cols="1" class="mr-3">-->
			<!--								<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdLightRed}`" :color="scdLightRed">close</v-icon>-->
			<!--							</v-col>-->
			<!--							<v-col><div>Click non vincente</div></v-col>-->
			<!--						</v-row>-->
			<!--						<v-row v-else-if="esitoClickday === 'Abbandonato / Screenshot mancante'" :style="`color:${scdRed};`" class="align-center no-gutters">-->
			<!--							<v-col cols="1" class="mr-3">-->
			<!--								<v-icon class="icon-outlined" size="20" :style="`border-color: ${scdRed}`" :color="scdRed">block</v-icon>-->
			<!--							</v-col>-->
			<!--							<v-col><div>Click abbandonato</div></v-col>-->
			<!--						</v-row>-->
			<!--					</div>-->
			<!--					<v-icon-->
			<!--						v-if="gamingAbilitato && amIAdminOrTeamleader && !iscrittoAlClickdayAttuale"-->
			<!--						color="green"-->
			<!--						small-->
			<!--						@click="dialogIscriviCliccatoreAlClickday = true"-->
			<!--						:disabled="isLoadingProfilo"-->
			<!--						class="ml-2"-->
			<!--					>-->
			<!--						mdi-plus-thick-->
			<!--					</v-icon>-->
			<!--					<v-icon-->
			<!--						v-if="gamingAbilitato && amIAdminOrTeamleader && iscrittoAlClickdayAttuale"-->
			<!--						color="green"-->
			<!--						small-->
			<!--						@click="apriDialogEsitoClickday()"-->
			<!--						:disabled="isLoadingProfilo"-->
			<!--						class="ml-2"-->
			<!--					>-->
			<!--						edit-->
			<!--					</v-icon>-->
			<!--				</div>-->
			<!--				<div style="font-size:15px; font-weight:600;" class="mb-2 mt-2">-->
			<!--					{{ esitoClickday === 'Vincente' ? 'Congratulazioni per aver vinto il Click Day!' : (esitoClickday === 'Non vincente' ? 'Purtroppo il tuo Click non è risultato vincente' : null) }}-->
			<!--				</div>-->
			<!--				-->
			<!--				<template v-if="iscrittoAlClickdayAttuale">-->
			<!--					<div style="font-size:14px; font-weight:500;">-->
			<!--						<span class="mr-2">Il tuo tempo è:</span>-->
			<!--						<span :style="`font-weight:600; color:${scdColorStrong};`"> {{ tempoClickdayNelRiquadro }}</span>-->
			<!--					</div>-->
			<!--					<div style="font-size:14px; font-weight:500;">-->
			<!--						<span class="mr-2">Compenso esiti provvisori:</span>-->
			<!--						<span :style="`font-weight:600; color:${scdColorStrong};`">{{ compensoFinaleEsitiProvvisori }} €</span>-->
			<!--					</div>-->
			<!--					<div style="font-size:14px; font-weight:500;">-->
			<!--						<span class="mr-2">Compenso esiti definitivi:</span>-->
			<!--						<span :style="`font-weight:600; color:${scdColorStrong};`">{{ compensoFinaleEsitiDefinitivi }} €</span>-->
			<!--					</div>-->
			<!--					<div style="font-size:14px; font-weight:500;">-->
			<!--						<span class="mr-2">Differenza compensi:</span>-->
			<!--						<span :style="`font-weight:600; color:${scdColorStrong};`">{{ differenzaCompensi }} €</span>-->
			<!--					</div>-->
			<!--					&lt;!&ndash;<div class="d-flex justify-center">&ndash;&gt;-->
			<!--					&lt;!&ndash;	<v-btn :color="scdColor" style="text-transform:none;" small depressed rounded class="white&#45;&#45;text _semi_bold mt-3 px-6"&ndash;&gt;-->
			<!--					&lt;!&ndash;				 @click="apriDialogIban()" :disabled="isLoadingProfilo"&ndash;&gt;-->
			<!--					&lt;!&ndash;	>&ndash;&gt;-->
			<!--					&lt;!&ndash;		Inserisci dati&ndash;&gt;-->
			<!--					&lt;!&ndash;	</v-btn>&ndash;&gt;-->
			<!--					&lt;!&ndash;</div>&ndash;&gt;-->
			<!--					<div style="font-size:14px; font-weight:500;">-->
			<!--						<span class="mr-2">Stato pagamento compenso: </span>-->
			<!--						<span :style="`font-weight:600; color:${scdColor};`">-->
			<!--							{{ statoPagamentoCompenso ? statoPagamentoCompenso : '&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;'  }}-->
			<!--						</span>-->
			<!--					</div>-->
			<!--					<div style="font-size:14px; font-weight:500;">-->
			<!--						<span class="mr-2">Data bonifico: </span>-->
			<!--						<span :style="`font-weight:600; color:${scdColor};`">-->
			<!--							{{ dataDelBonifico ? dateITFormatDDMMYYYY(dataDelBonifico) : '&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;'  }}-->
			<!--						</span>-->
			<!--					</div>-->
			<!--					<div style="font-size:14px; font-weight:500;">-->
			<!--						<span class="mr-2">Note compenso:</span>-->
			<!--						<span :style="`font-weight:600; color:${scdColor};`">-->
			<!--						{{ noteCompenso ? noteCompenso : '&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;'  }}-->
			<!--					</span>-->
			<!--					</div>-->
			<!--				</template>-->
			<!--			</div>-->
			<!--			-->
			<!--			<template v-if="iscrittoAlClickdayAttuale">-->
			<!--				<v-badge-->
			<!--					bordered-->
			<!--					:color="datiProfiloCliccatore.dati_inseriti ? 'success' : 'warning'"-->
			<!--					:icon="datiProfiloCliccatore.dati_inseriti ? 'mdi-check' : 'mdi-exclamation'"-->
			<!--					overlap-->
			<!--					left-->
			<!--					class="scatola-azzurra mb-4"-->
			<!--				>-->
			<!--					<div class="d-flex flex-column">-->
			<!--						<template v-if="!datiProfiloCliccatore.dati_inseriti">-->
			<!--							<div class="font-weight-medium mb-2">-->
			<!--								Inserisci i dati di fatturazione richiesti e poi carica la Ricevuta/Fattura-->
			<!--							</div>-->
			<!--							<v-btn-->
			<!--								rounded-->
			<!--								color="primary"-->
			<!--								style="text-transform:none"-->
			<!--								class="btn-wrap-text"-->
			<!--								@click="apriDialogDatiDiFatturazione()"-->
			<!--							>-->
			<!--								Inserisci-->
			<!--							</v-btn>-->
			<!--						</template>-->
			<!--						-->
			<!--						<template v-if="datiProfiloCliccatore.dati_inseriti">-->
			<!--							<div class="mb-1 font-weight-medium">-->
			<!--								IBAN: <span :style="`color: ${$vuetify.theme.currentTheme.primary}`">{{ datiProfiloCliccatore.iban }}</span>-->
			<!--							</div>-->
			<!--							-->
			<!--							<div-->
			<!--								v-if="datiProfiloCliccatore.codice_fiscale"-->
			<!--								class="mb-4 font-weight-medium"-->
			<!--							>-->
			<!--								CODICE FISCALE: <span :style="`color: ${$vuetify.theme.currentTheme.primary}`">{{ datiProfiloCliccatore.codice_fiscale }}</span>-->
			<!--							</div>-->
			<!--							-->
			<!--							&lt;!&ndash;TODO: serve ?&ndash;&gt;-->
			<!--							<div-->
			<!--								v-if="datiProfiloCliccatore.partita_iva"-->
			<!--								class="mb-4 font-weight-medium"-->
			<!--							>-->
			<!--								PARTITA IVA: <span :style="`color: ${$vuetify.theme.currentTheme.primary}`">{{ datiProfiloCliccatore.partita_iva }}</span>-->
			<!--							</div>-->
			<!--						</template>-->
			<!--						-->
			<!--						<div v-if="datiProfiloCliccatore.dati_inseriti" class="d-flex align-center mb-4">-->
			<!--							<div class="mr-4 font-weight-medium">Modifica dati di fatturazione</div>-->
			<!--							<v-btn-->
			<!--								fab-->
			<!--								x-small-->
			<!--								color="yellow lighten-4"-->
			<!--								@click="apriDialogDatiDiFatturazione()"-->
			<!--							>-->
			<!--								<v-icon color="yellow darken-3">mdi-pencil</v-icon>-->
			<!--							</v-btn>-->
			<!--						</div>-->
			<!--						-->
			<!--						<template v-if="datiProfiloCliccatore.dati_inseriti && !datiProfiloCliccatore.possesso_partita_iva">-->
			<!--							<template v-if="compensoFinaleEsitiProvvisori > 0">-->
			<!--								<div class="mb-2 font-weight-medium">-->
			<!--									Ricevuta PDF precompilata <span class="font-weight-bold">compenso esiti provvisori</span>-->
			<!--								</div>-->
			<!--								<v-btn-->
			<!--									rounded-->
			<!--									color="primary"-->
			<!--									style="text-transform:none"-->
			<!--									class="mb-5"-->
			<!--									@click="apriDialogScaricaModelloRicevuta(compensoFinaleEsitiProvvisori)"-->
			<!--								>-->
			<!--									<span class="mr-1">Scarica</span>-->
			<!--									<v-icon small>mdi-download</v-icon>-->
			<!--								</v-btn>-->
			<!--							</template>-->
			<!--							-->
			<!--							<template v-if="esitoClickday == 'Vincente Esiti Definitivi'">-->
			<!--								<div class="mb-2">-->
			<!--									Ricevuta PDF precompilata <span class="font-weight-bold">compenso differenza esiti definitivi</span>-->
			<!--								</div>-->
			<!--								<v-btn-->
			<!--									rounded-->
			<!--									color="primary"-->
			<!--									style="text-transform:none"-->
			<!--									class="btn-wrap-text"-->
			<!--									@click="apriDialogScaricaModelloRicevuta(differenzaCompensi)"-->
			<!--								>-->
			<!--									<span class="mr-1">Scarica</span>-->
			<!--									<v-icon small>mdi-download</v-icon>-->
			<!--								</v-btn>-->
			<!--							</template>-->
			<!--						</template>-->
			<!--					-->
			<!--					</div>-->
			<!--				</v-badge>-->
			<!--				-->
			<!--				<v-badge-->
			<!--					:value="compensoFinaleEsitiProvvisori > 0"-->
			<!--					bordered-->
			<!--					:color="pathRicevutaOFattura === null && compensoFinaleEsitiProvvisori > 0 ? 'warning' : 'success'"-->
			<!--					:icon="pathRicevutaOFattura === null && compensoFinaleEsitiProvvisori > 0 ? 'mdi-exclamation' : 'mdi-check'"-->
			<!--					overlap-->
			<!--					left-->
			<!--					class="scatola-azzurra mb-4"-->
			<!--				>-->
			<!--					<div class="d-flex flex-column ">-->
			<!--						<v-alert-->
			<!--							v-if="pathRicevutaOFattura === null && compensoFinaleEsitiProvvisori > 0"-->
			<!--							class="mb-4"-->
			<!--							color="warning"-->
			<!--						>-->
			<!--							<div class="mb-1 font-weight-bold">PAGAMENTO NON EROGABILE A CAUSA DI DATI MANCANTI</div>-->
			<!--							<div class="font-weight-medium">Caricare i dati di pagamento richiesti e la Ricevuta/Fattura entro il 14/08/2024 seguendo <a :style="`color: ${scdColorStrong}`" target="_blank" href="https://docs.google.com/document/d/1vGuhOzwRkECMSBMeHpPqewhPqh46YdnMpsiv1r97icM/edit">questa procedura</a>. In caso contrario, verrà considerata come una rinuncia implicita al pagamento, come previsto dal contratto.</div>-->
			<!--						</v-alert>-->
			<!--						-->
			<!--						<v-alert-->
			<!--							v-if="pathRicevutaOFattura !== null && compensoFinaleEsitiProvvisori > 0"-->
			<!--							class="mb-4"-->
			<!--							color="success"-->
			<!--						>-->
			<!--							<div class="mb-1 font-weight-bold">DATI CARICATI CORRETTAMENTE</div>-->
			<!--							<div class="font-weight-medium">Riceverai il compenso degli esiti provvisori tramite bonifico bancario entro il 03/09/2024.</div>-->
			<!--						</v-alert>-->
			<!--						-->
			<!--						<div class="d-flex justify-space-between align-center">-->
			<!--							<div class="font-weight-medium mr-1">Ricevuta o Fattura Esiti Provvisori</div>-->
			<!--							<div>-->
			<!--								<v-btn-->
			<!--									fab-->
			<!--									x-small-->
			<!--									color="green lighten-4"-->
			<!--									class="mr-1"-->
			<!--									:loading="isSelectingRicevutaOFattura || isUploadingRicevutaOFattura"-->
			<!--									:disabled="compensoFinaleEsitiProvvisori == 0 || !datiProfiloCliccatore.dati_inseriti"-->
			<!--									@click="handleFileRicevutaOFatturaImport()"-->
			<!--								>-->
			<!--									<v-icon color="green darken-3">mdi-upload</v-icon>-->
			<!--								</v-btn>-->
			<!--								-->
			<!--								<input-->
			<!--									ref="ricevutaOFatturaUploader"-->
			<!--									class="d-none"-->
			<!--									type="file"-->
			<!--									accept="application/pdf"-->
			<!--									@change="onFileRicevutaOFatturaChanged($event)"-->
			<!--								>-->
			<!--								-->
			<!--								<v-btn-->
			<!--									fab-->
			<!--									x-small-->
			<!--									color="blue lighten-4"-->
			<!--									:disabled="pathRicevutaOFattura === null || isUploadingRicevutaOFattura"-->
			<!--									:loading="isGettingRicevutaOFattura"-->
			<!--									@click="apriRicevutaOFatturaInUnaNuovaSchedaDelBrowser()"-->
			<!--								>-->
			<!--									<v-icon color="primary">mdi-magnify</v-icon>-->
			<!--								</v-btn>-->
			<!--							</div>-->
			<!--						</div>-->
			<!--						-->
			<!--						<v-alert-->
			<!--							type="error"-->
			<!--							:value="alertRicevutaOFatturaCaricataNonValida"-->
			<!--							transition="scale-transition"-->
			<!--							class="mt-4"-->
			<!--						>-->
			<!--							Il file caricato non è valido.<br>-->
			<!--							Assicurati che sia in formato PDF.-->
			<!--						</v-alert>-->
			<!--					</div>-->
			<!--				</v-badge>-->
			<!--				-->
			<!--				<v-badge-->
			<!--					:value="esitoClickday == 'Vincente Esiti Definitivi'"-->
			<!--					bordered-->
			<!--					:color="pathRicevutaOFatturaEsitiDefinitivi === null && esitoClickday == 'Vincente Esiti Definitivi' ? 'warning' : 'success'"-->
			<!--					:icon="pathRicevutaOFatturaEsitiDefinitivi === null && esitoClickday == 'Vincente Esiti Definitivi' ? 'mdi-exclamation' : 'mdi-check'"-->
			<!--					overlap-->
			<!--					left-->
			<!--					class="scatola-azzurra"-->
			<!--				>-->
			<!--					<div class="d-flex flex-column">-->
			<!--						<v-alert-->
			<!--							v-if="pathRicevutaOFatturaEsitiDefinitivi === null && esitoClickday == 'Vincente Esiti Definitivi'"-->
			<!--							class="mb-4"-->
			<!--							color="warning"-->
			<!--						>-->
			<!--							<div class="mb-1 font-weight-bold">PAGAMENTO NON EROGABILE A CAUSA DI DATI MANCANTI</div>-->
			<!--							<div class="font-weight-medium">Caricare i dati di pagamento richiesti e la Ricevuta/Fattura entro 40 giorni dalla pubblicazione degli elenchi cronologici definitivi seguendo <a :style="`color: ${scdColorStrong}`" target="_blank" href="https://docs.google.com/document/d/1vGuhOzwRkECMSBMeHpPqewhPqh46YdnMpsiv1r97icM/edit">questa procedura</a>. In caso contrario, verrà considerata come una rinuncia implicita al pagamento, come previsto dal contratto.</div>-->
			<!--						</v-alert>-->
			<!--						-->
			<!--						<v-alert-->
			<!--							v-if="pathRicevutaOFatturaEsitiDefinitivi !== null && esitoClickday == 'Vincente Esiti Definitivi'"-->
			<!--							class="mb-4"-->
			<!--							color="success"-->
			<!--						>-->
			<!--							<div class="mb-1 font-weight-bold">DATI CARICATI CORRETTAMENTE</div>-->
			<!--							<div class="font-weight-medium">Riceverai il compenso degli esiti definitivi tramite bonifico bancario entro 60 giorni dalla pubblicazione degli elenchi cronologici definitivi</div>-->
			<!--						</v-alert>-->
			<!--						-->
			<!--						<div class="d-flex justify-space-between align-center">-->
			<!--							<div class="font-weight-medium mr-1">Ricevuta o Fattura Esiti Definitivi</div>-->
			<!--							<div>-->
			<!--								<v-btn-->
			<!--									fab-->
			<!--									x-small-->
			<!--									color="green lighten-4"-->
			<!--									class="mr-1"-->
			<!--									:loading="isSelectingRicevutaOFatturaEsitiDefinitivi || isUploadingRicevutaOFatturaEsitiDefinitivi"-->
			<!--									:disabled="esitoClickday != 'Vincente Esiti Definitivi' || !datiProfiloCliccatore.dati_inseriti"-->
			<!--									@click="handleFileRicevutaOFatturaEsitiDefinitiviImport()"-->
			<!--								>-->
			<!--									<v-icon color="green darken-3">mdi-upload</v-icon>-->
			<!--								</v-btn>-->
			<!--								-->
			<!--								<input-->
			<!--									ref="ricevutaOFatturaEsitiDefinitiviUploader"-->
			<!--									class="d-none"-->
			<!--									type="file"-->
			<!--									accept="application/pdf"-->
			<!--									@change="onFileRicevutaOFatturaEsitiDefinitiviChanged($event)"-->
			<!--								>-->
			<!--								-->
			<!--								<v-btn-->
			<!--									fab-->
			<!--									x-small-->
			<!--									color="blue lighten-4"-->
			<!--									:disabled="pathRicevutaOFatturaEsitiDefinitivi === null || isUploadingRicevutaOFatturaEsitiDefinitivi"-->
			<!--									:loading="isGettingRicevutaOFatturaEsitiDefinitivi"-->
			<!--									@click="apriRicevutaOFatturaEsitiDefinitiviInUnaNuovaSchedaDelBrowser()"-->
			<!--								>-->
			<!--									<v-icon color="primary">mdi-magnify</v-icon>-->
			<!--								</v-btn>-->
			<!--							</div>-->
			<!--						</div>-->
			<!--						-->
			<!--						<v-alert-->
			<!--							type="error"-->
			<!--							:value="alertRicevutaOFatturaEsitiDefinitiviCaricataNonValida"-->
			<!--							transition="scale-transition"-->
			<!--							class="mt-4"-->
			<!--						>-->
			<!--							Il file caricato non è valido.<br>-->
			<!--							Assicurati che sia in formato PDF.-->
			<!--						</v-alert>-->
			<!--					</div>-->
			<!--				</v-badge>-->
			<!--			</template>-->
			<!--		</v-col>-->
			<!--	</v-row>-->
			<!--	-->
			<!--	<v-row>-->
			<!--		<v-col>-->
			<!--			<div-->
			<!--				v-if="(amIAdminOrTeamleader || computedAmIDeveloper) && computedClienteClickdayIt && !idCliccatore"-->
			<!--				class="d-flex mt-4"-->
			<!--			>-->
			<!--				<div v-if="computedAmIDeveloper || amIAdminOrTeamleader">-->
			<!--					<v-btn-->
			<!--						rounded-->
			<!--						depressed-->
			<!--						style="text-transform:none; color:white;"-->
			<!--						@click="apriDialogGestioneScreenshotsEdEsiti()"-->
			<!--						:color="scdGreen"-->
			<!--					>-->
			<!--						Gestione Screenshots ed Esiti-->
			<!--					</v-btn>-->
			<!--				</div>-->
			<!--			</div>-->
			<!--		</v-col>-->
			<!--	</v-row>-->
			<!--</div>-->

			<div class="_box_title d-flex">
				<div style="width:33%"></div>
				<div style="width:34%">
					<span class="mr-1">
						Amici invitati
					</span>
					<span>
						<v-progress-circular v-if="isLoadingProfilo" size="12" width="2" color="white" indeterminate></v-progress-circular>
						<span v-else class="white--color">{{ numeroAmiciConfermati }}/{{ numeroAmici }}</span>
					</span>
				</div>
				<div class="text-end" style="width:33%">
					<v-btn
						color="white"
						style="text-transform:none;"
						small
						depressed
						rounded
						class="font-weight-bold px-6 mr-2"
						@click="isInvitaAmiciAbilitato()"
						:disabled="isLoadingProfilo"
					>
						Aggiungi amici
					</v-btn>
				</div>
			</div>
			<v-data-table
				:headers="listaAmiciInvitatiHeaders"
				:items="listaAmiciInvitati"
				loading-text="In caricamento.."
				:loading="isLoadingListaAmiciInvitati"
				no-data-text="Nessun amico invitato"
				class="livelli-gaming-data-table"
				:footer-props="{'items-per-page-options':[5, 15, 30, -1], 'items-per-page-text': 'Amici per pagina'}"
				style="background-color: white; border-radius: 0"
			>
				<template slot="item" slot-scope="props">
					<tr>
						<td :style="`color:${scdColor};`" class="font-weight-medium">{{ props.item.email_utente_invitato }}</td>
						<td>
					<span
						class="success--text font-weight-medium"
						v-if="props.item.is_invito_accettato == true"
					>
						<v-icon class="success--text mr-1" small>
							check_circle
						</v-icon>
						Accettato
					</span>
						<span
							class="warning--text font-weight-medium"
							v-if="props.item.is_invito_accettato == false"
						>
							<v-icon class="warning--text mr-2">pending</v-icon>
							In attesa

							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-if="mostraBottoniInvitaAmico"
										small
										icon
										color="warning"
										v-bind="attrs"
										v-on="on"
										@click="reinvitaAmico(props.item.email_utente_invitato)"
									>
										<v-icon>mdi-refresh</v-icon>
									</v-btn>
								</template>
								<span>Clicca per reinviare l'email</span>
							</v-tooltip>

						</span>
						</td>
						<td :style="`color:${scdColor};`" class="font-weight-medium">{{ props.item.clickday_partecipati }}</td>
						<td :style="`color:${scdColor};`" class="font-weight-medium">{{ props.item.clickday_vinti }}</td>
						<td :style="`color:${scdColor};`" class="font-weight-medium">{{ props.item.clickday_persi }}</td>
						<td :style="`color:${scdColor};`" class="font-weight-medium">{{ props.item.clickday_non_assegnati }}</td>
						<!--<td>-->
						<!--	<img v-if="props.item.esito_clickday != null && props.item.esito_clickday != 'In attesa di esito'" style="height:30px" :src="immagineEsitoAmiciInvitati(props.item.esito_clickday)" >-->
						<!--</td>-->
					</tr>
				</template>
			</v-data-table>

			<v-dialog v-model="isInvitaAmiciDialogOpen" max-width="800" persistent>
				<v-card>
					<v-card-title>
						<span style="font-weight:600 !important;">Invita un amico</span>
						<v-spacer></v-spacer>
						<v-btn color="black--text" icon @click="isInvitaAmiciDialogOpen = false">
							<v-icon>close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-form ref="invitaAmiciForm">
							<v-col v-if="invitaAmiciAbilitato">
								<v-row>
									<v-col>
										<v-text-field outlined dense label="Email*" v-model="emailAmicoInvitato" required :rules="[vincoli.email, vincoli.required]"></v-text-field>
									</v-col>
								</v-row>
								<v-row class="mt-0">
									<v-col>
										<span :style="'color: ' + scdColor">
											<b>Inserisci qui l'email degli amici che vuoi invitare: riceveranno il tuo invito direttamente via email!</b>
										</span>
									</v-col>
								</v-row>
								<v-row>
									<v-col>
										<span :style="'color: ' + scdColor">
											<b>Nota Bene: in determinati periodi dell'anno, l'iscrizione per nuovi cliccatori potrebbe essere temporaneamente sospesa. Durante questi periodi, puoi comunque invitare i tuoi amici a partecipare, ma invece di iscriversi direttamente, verranno inseriti in una Lista d'Attesa. Quando le iscrizioni riapriranno, i tuoi amici nella Lista d'Attesa saranno avvisati e avranno la possibilità di partecipare ai futuri Click Day. Solo a quel punto, vedrai la loro partecipazione confermata in questa sezione.</b>
										</span>
									</v-col>
								</v-row>
							</v-col>
						</v-form>
						<div v-if="!invitaAmiciAbilitato" :style="`color:${scdColor}; font-weight:600; font-size:18px;`">
							Al momento non è possibile invitare amici.<br>Per maggiori informazioni chiedi al tuo coordinatore.
						</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<div v-if="invitaAmiciAbilitato" class="d-flex mb-3">
							<v-alert style="font-size: 14px; padding: 5px 10px !important;" :color="alertColor" v-if="alertType" :type="alertType" :value="true" outlined class="mx-4 mb-0">
								<span v-html="message"></span>
							</v-alert>
							<div>
								<v-btn
									v-if="mostraBottoniInvitaAmico"
									class="px-4 mr-2"
									style="text-transform:none;"
									depressed
									rounded
									color="primary"
									@click="isInvitaAmiciDialogOpen = false"
								>
									Annulla
								</v-btn>
								<v-btn
									v-if="mostraBottoniInvitaAmico"
									@click="invitaAmico()"
									:loading="isLoadingInvitaAmico"
									class="px-4 mr-3 white--text"
									style="text-transform:none;"
									depressed
									rounded
									:color="scdOrange"
								>Invita
								</v-btn>
								<v-btn
									v-if="mostraBottoniAmicoInvitato"
									class="px-4 mr-3 white--text"
									style="text-transform:none;"
									depressed
									rounded
									:color="scdColor"
									@click="isInvitaAmiciDialogOpen = false"
								>
									Chiudi
								</v-btn>
							</div>
						</div>

					</v-card-actions>
				</v-card>
			</v-dialog>

			<!--<v-dialog v-model="dialogModificaEsitoClickday" max-width="580" persistent>-->
			<!--	<modifica-esito-clickday-component-->
			<!--		:key="dialogModificaEsitoClickdayKey"-->
			<!--		:dati-esito-clickday="datiModificaEsitoClickday"-->
			<!--		@dati-esito-clickday-aggiornati="aggiornaDashboard()"-->
			<!--		@chiudi-dialog="dialogModificaEsitoClickday = false"-->
			<!--	></modifica-esito-clickday-component>-->
			<!--</v-dialog>-->

			<!--<v-dialog v-model="mostraDialogIban" max-width="580" persistent>-->
			<!--	<v-card>-->
			<!--		<v-card-title>-->
			<!--			<div style="font-weight:600 !important;" class="my-2 text-center">Inserisci i dati per ricevere il compenso</div>-->
			<!--			<v-spacer></v-spacer>-->
			<!--			<v-btn color="black&#45;&#45;text" icon @click="mostraDialogIban = false">-->
			<!--				<v-icon>close</v-icon>-->
			<!--			</v-btn>-->
			<!--		</v-card-title>-->
			<!--		<v-card-text>-->
			<!--			<v-form ref="datiIbanForm">-->
			<!--				<v-col>-->
			<!--					<v-row>-->
			<!--						<v-text-field-->
			<!--							outlined-->
			<!--							dense-->
			<!--							label="IBAN*"-->
			<!--							v-model="iban"-->
			<!--							@input="v => { iban = v.toUpperCase() }" required :rules="[vincoli.required, vincoli.iban]"-->
			<!--						></v-text-field>-->
			<!--					</v-row>-->
			<!--					<v-row class="flex-column" style="font-weight:600; font-size:16px">-->
			<!--						<div :style="`color:${scdColor}`">È intestato a te?</div>-->
			<!--						<v-radio-group-->
			<!--							row-->
			<!--							v-model="intestatoAlCliccatore"-->
			<!--							class="mt-1"-->
			<!--						>-->
			<!--							<v-radio key="si" label="SI" :value="true"></v-radio>-->
			<!--							<v-radio key="no" label="NO" :value="false"></v-radio>-->
			<!--						</v-radio-group>-->
			<!--					</v-row>-->
			<!--					<v-row v-if="intestatoAlCliccatore == false" class="mb-3">-->
			<!--						<v-text-field-->
			<!--							outlined-->
			<!--							label="Nome e Cognome dell'intestatario*"-->
			<!--							v-model="nomeCognomeIntestatario"-->
			<!--							required-->
			<!--							:rules="[vincoli.required]"-->
			<!--						></v-text-field>-->
			<!--						<div :style="`color:${scdColor}; font-weight:500;`">-->
			<!--							Poiché stai usando l'IBAN di un'altra persona, devi scrivere in carta semplice una dichiarazione in cui affermi di voler ricevere il compenso sull'IBAN dell'altra persona e ponete entrambi la firma. Invia poi questa dichiarazione all'email cliccatori@clickday.it<br>(Attenzione: questa dichiarazione è necessaria per ricevere il compenso, in caso di IBAN non intestato a te)-->
			<!--						</div>-->
			<!--					</v-row>-->
			<!--				</v-col>-->
			<!--			</v-form>-->
			<!--			<v-progress-linear v-if="caricamentoDatiIbanInCorso" class="mt-0 pt-0" :indeterminate="true" :color="scdColor"></v-progress-linear>-->
			<!--		</v-card-text>-->
			<!--		<v-card-actions>-->
			<!--			<v-spacer></v-spacer>-->
			<!--			<div class="d-flex">-->
			<!--				<v-alert style="font-size: 14px; padding: 5px 10px !important;" :color="alertColor" v-if="alertType" :type="alertType" :value="true" outlined class="mx-4 mb-0">-->
			<!--					<span v-html="message"></span>-->
			<!--				</v-alert>-->
			<!--				<div>-->
			<!--					<v-btn class="px-4 mr-2 white&#45;&#45;text" style="text-transform:none;" depressed rounded :color="scdColor" @click="mostraDialogIban = false">Chiudi</v-btn>-->
			<!--					<v-btn class="px-4 white&#45;&#45;text" style="text-transform:none;" depressed rounded :color="scdOrange" @click="salvaDatiIban()">Salva</v-btn>-->
			<!--				</div>-->
			<!--			</div>-->
			
			<!--		</v-card-actions>-->
			<!--	</v-card>-->
			<!--</v-dialog>-->
			
			<!--<v-dialog v-model="dialogIscriviCliccatoreAlClickday" max-width="580" persistent>-->
			<!--	<v-card>-->
			<!--		<v-card-title>-->
			<!--			<div style="font-weight:600 !important;">-->
			<!--				Iscrivere il Cliccatore al Click Day?-->
			<!--			</div>-->
			<!--		</v-card-title>-->
			<!--		<v-card-text>-->
			<!--		</v-card-text>-->
			<!--		<v-card-actions>-->
			<!--			<v-spacer></v-spacer>-->
			<!--			<v-btn-->
			<!--				class="px-4 mr-2 white&#45;&#45;text"-->
			<!--				style="text-transform:none;"-->
			<!--				depressed-->
			<!--				rounded-->
			<!--				:color="scdColor"-->
			<!--				@click="dialogIscriviCliccatoreAlClickday = false"-->
			<!--				:disabled="iscrizioneAlClickdayInCorso"-->
			<!--			>-->
			<!--				Annulla-->
			<!--			</v-btn>-->
			<!--			<v-btn-->
			<!--				class="px-4 white&#45;&#45;text"-->
			<!--				style="text-transform:none;"-->
			<!--				depressed-->
			<!--				rounded-->
			<!--				:color="scdOrange"-->
			<!--				@click="iscriviCliccatoreAlClickday()"-->
			<!--				:loading="iscrizioneAlClickdayInCorso"-->
			<!--			>-->
			<!--				Iscrivi-->
			<!--			</v-btn>-->
			<!--		</v-card-actions>-->
			<!--	</v-card>-->
			<!--</v-dialog>-->
			
			<!--<v-dialog-->
			<!--	v-model="dialogGestioneScreenshotsEdEsiti"-->
			<!--	persistent-->
			<!--	scrollable-->
			<!--&gt;-->
			<!--	<gestione-screenshot-ed-esiti-component-->
			<!--		:key="gestioneScreenshotsEdEsitiKey"-->
			<!--		:id-bando="idBando"-->
			<!--		:nome-bando="nomeBando"-->
			<!--		@close="dialogGestioneScreenshotsEdEsiti = false"-->
			<!--	></gestione-screenshot-ed-esiti-component>-->
			<!--</v-dialog>-->
			
			<!--<v-dialog-->
			<!--	v-model="dialogDatiDiFatturazione"-->
			<!--	persistent-->
			<!--	scrollable-->
			<!--	width="1000px"-->
			<!--&gt;-->
			<!--	<dati-di-fatturazione-component-->
			<!--		:key="dialogDatiDiFatturazioneKey"-->
			<!--		:value="datiProfiloCliccatore"-->
			<!--		:id-cliccatore="idCliccatore"-->
			<!--		@close="dialogDatiDiFatturazione = false"-->
			<!--		@salvataggio-eseguito="aggiornaDashboard()"-->
			<!--	></dati-di-fatturazione-component>-->
			<!--</v-dialog>-->
			
			<!--<v-dialog-->
			<!--	v-model="dialogNumeroProgressivoRicevuta"-->
			<!--	:key="dialogNumeroProgressivoRicevutaKey"-->
			<!--	persistent-->
			<!--	scrollable-->
			<!--	width="500px"-->
			<!--&gt;-->
			<!--	<v-card>-->
			<!--		<v-card-title></v-card-title>-->
			<!--		<v-card-text>-->
			<!--			<v-row>-->
			<!--				<v-col>-->
			<!--					<div class="font-weight-medium black&#45;&#45;text">-->
			<!--						Inserisci qui sotto il numero della ricevuta. Metti 1 se è la prima ricevuta che emetti nel 2024, 2 se è la seconda e via dicendo.-->
			<!--					</div>-->
			<!--				</v-col>-->
			<!--			</v-row>-->
			<!--			<v-row>-->
			<!--				<v-col cols="5">-->
			<!--					<v-form ref="numeroProgressivoForm">-->
			<!--						<v-text-field-->
			<!--							v-model="numeroProgressivoRicevuta"-->
			<!--							type="number"-->
			<!--							min="1"-->
			<!--							:rules="[vincoli.required, vincoli.isNumber]"-->
			<!--							outlined-->
			<!--							dense-->
			<!--						>-->
			<!--						</v-text-field>-->
			<!--					</v-form>-->
			<!--				</v-col>-->
			<!--			</v-row>-->
			<!--		</v-card-text>-->
			<!--		<v-card-actions>-->
			<!--			<v-spacer></v-spacer>-->
			<!--			<v-btn-->
			<!--				:color="scdRed"-->
			<!--				class="white&#45;&#45;text"-->
			<!--				rounded-->
			<!--				@click="dialogNumeroProgressivoRicevuta = false"-->
			<!--			>-->
			<!--				Annulla-->
			<!--			</v-btn>-->
			<!--			<v-btn-->
			<!--				rounded-->
			<!--				style="text-transform:none; color:white;"-->
			<!--				@click="scaricaPdfModelloRicevuta()"-->
			<!--				:color="scdOrange"-->
			<!--			>-->
			<!--				Scarica-->
			<!--			</v-btn>-->
			<!--		</v-card-actions>-->
			<!--	</v-card>-->
			<!--</v-dialog>-->
		</div>
	</div>
</template>

<script>
import mixin from '../../mixins';
import { saveAs } from 'file-saver';

export default {
	props: ['idCliccatore'],
	data() {
		return {
			isLoading: false,
			isLoadingChanges: false,
			message: null,
			alertColor: null,
			alertType: null,
			
			/**
			 * Ho aggiunto questo oggetto successivamente per passare questi dati a
			 * dati-di-fatturazione-component ma il codice in questa pagina non lo usa.
			 */
			datiProfiloCliccatore: {},

			// iscrittoAlClickdayAttuale: null,
			usernameCliccatore: null,
			codiceCliccatore: null,
			nomeSquadra: null,
			clickdayPartecipati: null,
			clickdayVinti: null,
			clickdayPersi: null,
			clickdayAbbandonati: null,
			clickdayNonAssegnati: null,
			gamedayPartecipati: null,
			gamedayVinti: null,
			gamedayPersi: null,
			gamedayAbbandonati: null,
			gamedayPartecipatiBandoAttuale: null,
			gamedayVintiBandoAttuale: null,
			gamedayPersiBandoAttuale: null,
			gamedayAbbandonatiBandoAttuale: null,
			
			isLoadingDatiClassificaCliccatore: false,
			puntiClassifica: null,
			posizioneClassifica: null,

			idBando: null,
			nomeBando: null,
			dataOraClickDay: null,
			compensoVittoria: null,
			compensoSelezione: null,
			compensoPerdita: null,
			compensoVittoriaAmico: null,
			puntiClickdayVinto: null,
			puntiClickdayPerso: null,
			gamedaysAbilitati: false,
			bonusVittorieAmiciAbilitati: false,
			sommaCompensiGamedaysVintiEPersiClickdayVinto: null,
			sommaCompensiGamedaysVintiEPersiClickdayPerso: null,
			sommaCompensiPerAmiciVincentiEsitiDefinitivi: null,
			sommaCompensiPerAmiciVincentiEsitiProvvisori: null,

			headers: [
				{ text: "Livello", value: "livello", sortable: false },
				{ text: "Soglia game score", value: "soglia_percentuale", sortable: false },
				{ text: "Bonus in caso di perdita (non cumulativi)", value: "bonus_perdita", sortable: false },
				{ text: "Bonus in caso di vittoria (non cumulativi)", value: "bonus_vittoria", sortable: false }
			],
			listaAmiciInvitatiHeaders: [
				{ text: "Email", value: "email_utente_invitato" },
				{ text: "Stato invito", value: "is_invito_accettato" },
				{ text: "Click Day partecipati", value: "clickday_partecipati" },
				{ text: "Click Day vinti", value: "clickday_vinti" },
				{ text: "Click Day persi", value: "clickday_persi" },
				{ text: "Click Day non assegnati", value: "clickday_non_assegnati" },
				// { text: "Esito Clickday", value: "esito_clickday" },
			],

			livelli: [],
			styleOrangeTr: 'background-color: rgba(240, 131, 57, 0.8); color: #fff; ',

			// imgPathLivelloAttuale: null,
			// almenoXSimulazioni: false,
			punteggioAttuale: null,
			migliorPunteggio: null,
			migliorPunteggioString: '',
			percentualeVincentiUltime100: null,
			// livelloCliccatore: null,
			// isVeterano: null,
			// simulazioniTotali: null,
			// simulazioniMancanti: null,
			minimoSimulazioniSelezione: null,
			minimoWinScoreSelezione: null,

			invitaAmiciAbilitato: null,

			numeroAmici: null,
			numeroAmiciConfermati: null,

			isAmiciInvitatiDialogOpen: false,
			listaAmiciInvitati: [],
			isLoadingListaAmiciInvitati: true,
			isLoadingInvitaAmico: false,

			isInvitaAmiciDialogOpen: false,
			mostraBottoniInvitaAmico: true,
			mostraBottoniAmicoInvitato: false,
			emailAmicoInvitato: null,

			isLoadingProfilo: false,

			caricamentoDatiIbanInCorso: false,
			iban: null,
			intestatoAlCliccatore: true,
			nomeCognomeIntestatario: null,
			mostraDialogIban: false,
			dataDelBonifico: null,

			esitoClickday: null,
			tempoClickday: null,
			tempoClickdayNelRiquadro: null,
			compensoFinaleEsitiProvvisori: null,
			compensoFinaleEsitiDefinitivi: null,

			compensoFinalePersonalizzato: null,
			compensoFinalePersonalizzatoEsitiDefinitivi: null,

			statoPagamentoCompenso: null,
			noteCompenso: null,
			
			dialogModificaEsitoClickdayKey: 0,
			dialogModificaEsitoClickday: false,

			datiModificaEsitoClickday: {
				idCliccatore: null,
				esitoClickday: null,
				tempoClickday: null,
				compensoFinale: null,
				compensoFinalePersonalizzatoEsitiDefinitivi: null,
				noteCompenso: null,
				statoPagamentoCompenso: null
			},

			// urlImmagineEsitoClickday: '/img/clickday/clickday_waiting.png',
			
			dialogIscriviCliccatoreAlClickday: false,
			iscrizioneAlClickdayInCorso: false,
			
			dialogGestioneScreenshotsEdEsiti: false,
			gestioneScreenshotsEdEsitiKey: 0,
			
			ricevutaOFattura: null, // file pdf
			pathRicevutaOFattura: null,
			isSelectingRicevutaOFattura: false,
			isUploadingRicevutaOFattura: false,
			isGettingRicevutaOFattura: false,
			
			ricevutaOFatturaEsitiDefinitivi: null, // file pdf
			pathRicevutaOFatturaEsitiDefinitivi: null,
			isSelectingRicevutaOFatturaEsitiDefinitivi: false,
			isUploadingRicevutaOFatturaEsitiDefinitivi: false,
			isGettingRicevutaOFatturaEsitiDefinitivi: false,
			
			// dialogCfOPiva: false,
			// cfOPiva: null,
			// isSavingCfOPiva: false,
			
			dialogDatiDiFatturazioneKey: 0,
			dialogDatiDiFatturazione: false,
			
			compensoPerModelloRicevuta: null,
			numeroProgressivoRicevuta: null,
			dialogNumeroProgressivoRicevuta: false,
			dialogNumeroProgressivoRicevutaKey: 0,
			
			alertRicevutaOFatturaCaricataNonValida: false,
			alertRicevutaOFatturaEsitiDefinitiviCaricataNonValida: false,
			
			clickDayBoxKey: 0
		}
	},

	computed: {
		// aggiornamento: restituito nel back-end come totale_compenso_vittoria_esiti_provvisori
		// totaleCompensoVittoriaEsitiProvvisori() {
		// 	return (this.selezioneSuperata ? this.compensoSelezione : 0)
		// 		+ this.compensoVittoria
		// 		+ this.sommaCompensiGamedaysVintiEPersiClickdayVinto
		// 		+ this.sommaCompensiPerAmiciVincentiEsitiProvvisori;
		// },
		// aggiornamento: restituito nel back-end come totale_compenso_vittoria_esiti_definitivi
		// totaleCompensoVittoriaEsitiDefinitivi() {
		// 	return (this.selezioneSuperata ? this.compensoSelezione : 0)
		// 		+ this.compensoVittoria
		// 		+ this.sommaCompensiGamedaysVintiEPersiClickdayVinto
		// 		+ this.sommaCompensiPerAmiciVincentiEsitiDefinitivi;
		// },
		// aggiornamento: restituito nel back-end come totale_compenso_perdita_esiti_provvisori
		// totaleCompensoPerditaEsitiProvvisori() {
		// 	return (this.selezioneSuperata ? this.compensoSelezione : 0)
		// 		+ this.compensoPerdita
		// 		+ this.sommaCompensiGamedaysVintiEPersiClickdayPerso
		// 		+ this.sommaCompensiPerAmiciVincentiEsitiProvvisori
		// },
		// aggiornamento: restituito nel back-end come totale_compenso_perdita_esiti_definitivi
		// totaleCompensoPerditaEsitiDefinitivi() {
		// 	return (this.selezioneSuperata ? this.compensoSelezione : 0)
		// 		+ this.compensoPerdita
		// 		+ this.sommaCompensiGamedaysVintiEPersiClickdayPerso
		// 		+ this.sommaCompensiPerAmiciVincentiEsitiDefinitivi
		// },
		// aggiornamento: restituito nel back-end come selezione_superata
		// selezioneSuperata() {
		// 	return this.migliorPunteggio >= this.minimoWinScoreSelezione;
		// },
		// fatto nel backend
		// differenzaCompensi() {
		// 	return this.compensoFinaleEsitiDefinitivi > this.compensoFinaleEsitiProvvisori
		// 		? this.compensoFinaleEsitiDefinitivi - this.compensoFinaleEsitiProvvisori
		// 		: 0;
		// }
	},

	watch: {
		// datiProfiloCliccatore(val) {
		// 	console.log(val)
		// }
		// esitoClickday(newVal) {
		// 	this.componiRiquadroEsitoClickday(newVal);
		// },
		// idSquadraSelezionata(id) {
		// 	this.getIscritti(id);
		// }
	},
	async created() {
		this.isLoading = true;
		await this.getProfiloCliccatore();
		this.getDatiClassificaCliccatore();
		this.getListaAmiciInvitati();
		// this.handleCompensoEsitiProvvisoriClickday(this.esitoClickday);
		// this.handleCompensoEsitiDefinitiviClickday(this.esitoClickday);
		// this.handleTempoClickDay(this.esitoClickday);
		this.isLoading = false;
		// Serve ad abilitare l'invito solo per l'utente 2 quando blocco la funzionalità
		// if (window.__ID_CLIENTE__ == '2') {
		//   this.invitaAmiciDark = true;
		//   this.invitaAmiciButtonDisabled = false;
		// }


	},

	methods: {
		getProfiloCliccatore() {
			this.isLoadingProfilo = true;
			
			return axios.get(this.idCliccatore
				? '/clickdayit/get_profilo_cliccatore/' + this.idCliccatore
				: '/clickdayit/get_profilo_cliccatore'
			)
				.then(response => {
					this.datiProfiloCliccatore = response.data;
					// console.log(this.datiProfiloCliccatore);
					
					// TODO: cancellare tutte le righe inutilizzate ora che ho spostato il codice del clickday in un componente
					// this.iscrittoAlClickdayAttuale = response.data.iscritto_al_clickday_attuale;
					this.usernameCliccatore = response.data.username_cliccatore;
					this.codiceCliccatore = response.data.codice_cliccatore;
					this.nomeSquadra = response.data.nome_squadra;
					this.clickdayPartecipati = response.data.clickday_partecipati;
					this.clickdayVinti = response.data.clickday_vinti;
					this.clickdayPersi = response.data.clickday_persi;
					this.clickdayAbbandonati = response.data.clickday_abbandonati;
					this.clickdayNonAssegnati = response.data.clickday_non_assegnati;
					this.gamedayPartecipati = response.data.gameday_partecipati;
					this.gamedayVinti = response.data.gameday_vinti;
					this.gamedayPersi = response.data.gameday_persi;
					this.gamedayAbbandonati = response.data.gameday_abbandonati;
					this.gamedayPartecipatiBandoAttuale = response.data.gameday_partecipati_bando_attuale;
					this.gamedayVintiBandoAttuale = response.data.gameday_vinti_bando_attuale;
					this.gamedayPersiBandoAttuale = response.data.gameday_persi_bando_attuale;
					this.gamedayAbbandonatiBandoAttuale = response.data.gameday_abbandonati_bando_attuale;
					this.idBando = response.data.id_bando;
					this.nomeBando = response.data.nome_bando;
					this.dataOraClickDay = response.data.data_ora_clickday;
					this.compensoVittoria = response.data.compenso_vittoria;
					this.compensoSelezione = response.data.compenso_selezione;
					this.compensoPerdita = 0;
					this.compensoVittoriaAmico = response.data.compenso_vittoria_amico;
					this.puntiClickdayVinto = response.data.punti_clickday_vinto;
					this.puntiClickdayPerso = response.data.punti_clickday_perso;
					this.gamedaysAbilitati = response.data.gamedays_abilitati;
					this.bonusVittorieAmiciAbilitati = response.data.bonus_vittorie_amici_abilitati;
					this.sommaCompensiGamedaysVintiEPersiClickdayVinto = response.data.somma_compensi_gamedays_vinti_e_persi_clickday_vinto;
					this.sommaCompensiGamedaysVintiEPersiClickdayPerso = response.data.somma_compensi_gamedays_vinti_e_persi_clickday_perso;
					this.sommaCompensiPerAmiciVincentiEsitiProvvisori = response.data.somma_compensi_per_amici_vincenti_esiti_provvisori;
					this.sommaCompensiPerAmiciVincentiEsitiDefinitivi = response.data.somma_compensi_per_amici_vincenti_esiti_definitivi;
					this.compensoFinalePersonalizzato = response.data.compenso_finale;
					this.compensoFinalePersonalizzatoEsitiDefinitivi = response.data.compenso_finale_personalizzato_esiti_definitivi;
					this.statoPagamentoCompenso = response.data.stato_pagamento_compenso;
					// this.opzioniStatoPagamentoCompenso = response.data.opzioni_stato_pagamento_compenso;
					// this.opzioniEsitoClickday = response.data.opzioni_esito_clickday;
					this.noteCompenso = response.data.note_compenso;
					
					this.minimoSimulazioniSelezione = response.data.minimo_simulazioni_selezione;
					this.minimoWinScoreSelezione = response.data.minimo_win_score_selezione;
					
					let migliorPunteggio = response.data.miglior_punteggio/*.punteggio*/;
					if (migliorPunteggio != null) {
						this.migliorPunteggioString = migliorPunteggio + ' %';
						this.migliorPunteggio = response.data.miglior_punteggio/*.punteggio*/;
					} else {
						this.migliorPunteggioString = '-';
					}

					// se è il Bando Inail 2020 devo aggiungere al compenso finale il bonus dei livelli
					if (this.idBando === 1) {
						const data = this.getLivello(response.data.miglior_punteggio.punteggio); // dal mixins
						// this.livelloCliccatore = data.livello;
						this.compensoVittoria += data.bonusVittoria;
						this.compensoPerdita += data.bonusPerdita;
					}
					// this.imgPathLivelloAttuale = `/img/livelli_gaming/${this.livelloCliccatore}.png`;

					// TODO: credo sia meglio restituire queste info nel metodo getListaAmiciInvitati(), magari rinominando il metodo
					this.numeroAmici = response.data.numero_amici;
					this.numeroAmiciConfermati = response.data.numero_amici_confermati;

					// this.simulazioniTotali = response.data.simulazioni_totali;
					// this.simulazioniMancanti = response.data.simulazioni_mancanti;

					this.esitoClickday = response.data.esito_clickday;
					this.tempoClickday = response.data.tempo_clickday;

					this.iban = response.data.iban;
					this.nomeCognomeIntestatario = response.data.intestatario_iban;
					this.dataDelBonifico = response.data.data_bonifico;
					
					if (this.nomeCognomeIntestatario != null) {
						this.intestatoAlCliccatore = false;
					}
					
					this.pathRicevutaOFattura = response.data.path_ricevuta_o_fattura;
					this.pathRicevutaOFatturaEsitiDefinitivi = response.data.path_ricevuta_o_fattura_esiti_definitivi;
					// this.cfOPiva = response.data.cf_o_piva;
				})
				.finally(() => {
					this.isLoadingProfilo = false;
				});
		},
		getDatiClassificaCliccatore() {
			this.isLoadingDatiClassificaCliccatore = true;
			const url = this.idCliccatore
				? `/clickdayit/get_dati_classifica_cliccatore/${this.idCliccatore}`
				: '/clickdayit/get_dati_classifica_cliccatore';
			
			axios.get(url)
				.then(response => {
					this.puntiClassifica = response.data.punti_classifica;
					this.posizioneClassifica = response.data.posizione_classifica;
				})
				.finally(() => {
					this.isLoadingDatiClassificaCliccatore = false;
				})
		},
		isInvitaAmiciAbilitato() {
			return axios.get('/clickdayit/isInvitaAmiciAbilitato')
				.then(response => {
					this.invitaAmiciAbilitato = response.data;

					if (this.invitaAmiciAbilitato) {
						this.mostraBottoniInvitaAmico = true;
						this.mostraBottoniAmicoInvitato = false;

					} else if (!this.invitaAmiciAbilitato) {

					}
				})
				.catch(error => {

				})
				.finally(() => {
					this.alertType = null
					this.isInvitaAmiciDialogOpen = true;
				})
		},
		async invitaAmico(isReinvio = false) {
			await this.isInvitaAmiciAbilitato();

			if (this.$refs.invitaAmiciForm.validate() && this.invitaAmiciAbilitato) {
				this.isLoadingInvitaAmico = true;
				
				axios.post('clickdayit/invitaAmico', {
					emailAmicoInvitato: this.emailAmicoInvitato,
					idCliccatore: this.idCliccatore
				} )
					.then(response => {
						if (response.data.hasError) {
							this.alertType = "error";
							this.message = response.data.message;
							this.alertColor = 'red';
						} else {
							this.alertType = "success";
							if(!isReinvio)
								this.message = "Invito inviato correttamente!";
							else
								this.message = "Invito re-inviato correttamente!";
							this.alertColor = 'green';

							this.mostraBottoniInvitaAmico = false;
							this.mostraBottoniAmicoInvitato = true;
							
							this.getListaAmiciInvitati();
						}
					})
					.catch(error => {
						this.alertType = "error";
						this.message = "Errore, invito non riuscito";
						this.alertColor = 'red';
					})
					.finally(() => {
						this.isLoadingInvitaAmico = false;
					});
			}
		},

		async reinvitaAmico(email) {
			// Imposto manualmente il campo email e reinvia utilizzando la stessa funzione
			this.emailAmicoInvitato = email;

			await this.invitaAmico(true);
		},

		getListaAmiciInvitati: function() {
			axios
				.get(this.idCliccatore ? '/clickdayit/getListaAmiciInvitati/' + this.idCliccatore : '/clickdayit/getListaAmiciInvitati')
				.then(response => {
					this.listaAmiciInvitati = response.data;
				})
				.catch(error => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingListaAmiciInvitati = false;
				});

		},
		// apriDialogEsitoClickday(cliccatore = null) {
		// 	this.dialogModificaEsitoClickdayKey++;
		//
		// 	if (cliccatore) {
		// 		this.datiModificaEsitoClickday = {
		// 			idCliccatore: cliccatore.id,
		// 			esitoClickday: cliccatore.pivot.esito_clickday,
		// 			tempoClickday: cliccatore.pivot.tempo_clickday,
		// 			compensoFinale:
		// 				this.compensoFinalePersonalizzato !== null
		// 				? this.compensoFinalePersonalizzato
		// 				: null,
		// 			compensoFinalePersonalizzatoEsitiDefinitivi:
		// 				this.compensoFinalePersonalizzatoEsitiDefinitivi !== null
		// 				? this.compensoFinalePersonalizzatoEsitiDefinitivi
		// 				: null,
		// 			statoPagamentoCompenso: this.statoPagamentoCompenso,
		// 			noteCompenso: this.noteCompenso,
		// 			dataDelBonifico: this.dataDelBonifico
		// 		}
		// 	}
		// 	else {
		// 		this.datiModificaEsitoClickday = {
		// 			idCliccatore: this.idCliccatore,
		// 			esitoClickday: this.esitoClickday,
		// 			tempoClickday: this.tempoClickday,
		// 			compensoFinale:
		// 				this.compensoFinalePersonalizzato !== null
		// 				? this.compensoFinalePersonalizzato
		// 				: null,
		// 			compensoFinalePersonalizzatoEsitiDefinitivi:
		// 				this.compensoFinalePersonalizzatoEsitiDefinitivi !== null
		// 				? this.compensoFinalePersonalizzatoEsitiDefinitivi
		// 				: null,
		// 			statoPagamentoCompenso: this.statoPagamentoCompenso,
		// 			noteCompenso: this.noteCompenso,
		// 			dataDelBonifico: this.dataDelBonifico
		// 		}
		// 	}
		//
		// 	this.dialogModificaEsitoClickday = true;
		// },
		// apriDialogIban() {
		// 	this.mostraDialogIban = true;
		// },
		// salvaDatiIban() {
		// 	if(this.$refs.datiIbanForm.validate()) {
		// 		this.caricamentoDatiIbanInCorso = true;
		// 		if (this.intestatoAlCliccatore) {
		// 			this.nomeCognomeIntestatario = null;
		// 		}
		// 		axios.post('/clickdayit/salva_dati_iban', {
		// 			utente_id: this.idCliccatore,
		// 			iban: this.iban,
		// 			intestatario_iban: this.nomeCognomeIntestatario
		// 		})
		// 			.then(response => {
		// 				this.mostraDialogIban = false;
		// 			})
		// 			.finally(() => {
		// 				this.caricamentoDatiIbanInCorso = false;
		// 			})
		// 	}
		//
		// },
		// handleFileRicevutaOFatturaImport() {
		// 	this.isSelectingRicevutaOFattura = true;
		// 	// After obtaining the focus when closing the FilePicker, return the button state to normal
		// 	window.addEventListener('focus', () => {
		// 		this.isSelectingRicevutaOFattura = false
		// 	}, { once: true });
		//
		// 	// Trigger click on the FileInput
		// 	this.$refs.ricevutaOFatturaUploader.click();
		// },
		// uploadRicevutaOFattura() {
		// 	this.isUploadingRicevutaOFattura = true;
		//
		// 	let formData = new FormData();
		// 	formData.append('ricevuta_o_fattura', this.ricevutaOFattura);
		// 	if (this.idCliccatore) formData.append('utente_id', this.idCliccatore);
		// 	formData.append('bando_id', this.idBando);
		//
		// 	axios.post('/cliccatori/upload-ricevuta-o-fattura', formData, {
		// 		headers: { 'Content-Type': 'multipart/form-data' }
		// 	})
		// 		.then(response => {
		// 			this.pathRicevutaOFattura = response.data;
		// 		})
		// 		.catch(error => {
		// 			if (error.response.status == 422) {
		// 				this.alertRicevutaOFatturaCaricataNonValida = true;
		// 				setTimeout(() => {
		// 					this.alertRicevutaOFatturaCaricataNonValida = false
		// 				},10000)
		// 			}
		// 			console.log(error.response.status)
		// 		})
		// 		.finally(() => {
		// 			this.isUploadingRicevutaOFattura = false;
		// 		})
		// },
		// onFileRicevutaOFatturaChanged(e) {
		// 	this.ricevutaOFattura = e.target.files[0];
		// 	// Do whatever you need with the file, like reading it with FileReader
		// 	this.uploadRicevutaOFattura();
		// },
		// apriRicevutaOFatturaInUnaNuovaSchedaDelBrowser() {
		// 	this.isGettingRicevutaOFattura = true;
		// 	axios.post('/cliccatori/get-ricevuta-o-fattura', {
		// 		path_ricevuta_o_fattura: this.pathRicevutaOFattura
		// 	}, {
		// 		responseType: 'arraybuffer'
		// 	})
		// 		.then(response => {
		// 			// this.ricevutaPdf = response.data;
		// 			const file = new Blob([response.data], { type: 'application/pdf' });
		// 			const fileURL = URL.createObjectURL(file);
		// 			window.open(fileURL);
		// 		})
		// 		.finally(() => {
		// 			this.isGettingRicevutaOFattura = false;
		// 		})
		// },
		// handleFileRicevutaOFatturaEsitiDefinitiviImport() {
		// 	this.isSelectingRicevutaOFatturaEsitiDefinitivi = true;
		// 	// After obtaining the focus when closing the FilePicker, return the button state to normal
		// 	window.addEventListener('focus', () => {
		// 		this.isSelectingRicevutaOFatturaEsitiDefinitivi = false
		// 	}, { once: true });
		//
		// 	// Trigger click on the FileInput
		// 	this.$refs.ricevutaOFatturaEsitiDefinitiviUploader.click();
		// },
		// uploadRicevutaOFatturaEsitiDefinitivi() {
		// 	this.isUploadingRicevutaOFatturaEsitiDefinitivi = true;
		//
		// 	let formData = new FormData();
		// 	formData.append('ricevuta_o_fattura_esiti_definitivi', this.ricevutaOFatturaEsitiDefinitivi);
		// 	if (this.idCliccatore) formData.append('utente_id', this.idCliccatore);
		// 	formData.append('bando_id', this.idBando);
		// 	axios.post('/cliccatori/upload-ricevuta-o-fattura-esiti-definitivi', formData, {
		// 		headers: { 'Content-Type': 'multipart/form-data' }
		// 	})
		// 		.then(response => {
		// 			this.pathRicevutaOFatturaEsitiDefinitivi = response.data;
		// 		})
		// 		.catch(error => {
		// 			if (error.response.status == 422) {
		// 				this.alertRicevutaOFatturaEsitiDefinitiviCaricataNonValida = true;
		// 				setTimeout(() => {
		// 					this.alertRicevutaOFatturaEsitiDefinitiviCaricataNonValida = false
		// 				},10000)
		// 			}
		// 		})
		// 		.finally(() => {
		// 			this.isUploadingRicevutaOFatturaEsitiDefinitivi = false;
		// 		})
		// },
		// onFileRicevutaOFatturaEsitiDefinitiviChanged(e) {
		// 	this.ricevutaOFatturaEsitiDefinitivi = e.target.files[0];
		// 	// Do whatever you need with the file, like reading it with FileReader
		// 	this.uploadRicevutaOFatturaEsitiDefinitivi();
		// },
		// apriRicevutaOFatturaEsitiDefinitiviInUnaNuovaSchedaDelBrowser() {
		// 	this.isGettingRicevutaOFatturaEsitiDefinitivi = true;
		// 	axios.post('/cliccatori/get-ricevuta-o-fattura-esiti-definitivi', {
		// 		path_ricevuta_o_fattura_esiti_definitivi: this.pathRicevutaOFatturaEsitiDefinitivi
		// 	}, {
		// 		responseType: 'arraybuffer'
		// 	})
		// 		.then(response => {
		// 			// this.ricevutaPdf = response.data;
		// 			const file = new Blob([response.data], { type: 'application/pdf' });
		// 			const fileURL = URL.createObjectURL(file);
		// 			window.open(fileURL);
		// 		})
		// 		.finally(() => {
		// 			this.isGettingRicevutaOFatturaEsitiDefinitivi = false;
		// 		})
		// },
		// apriDialogCfOPiva() {
		// 	this.dialogCfOPiva = true;
		// },
		// saveCfOPiva() {
		// 	this.isSavingCfOPiva = true;
		// 	axios.patch('/clickdayit/cf-o-piva', {
		// 		utente_id: this.idCliccatore,
		// 		cf_o_piva: this.cfOPiva
		// 	})
		// 		.then(() => {
		// 			this.dialogCfOPiva = false;
		// 			this.isSavingCfOPiva = false;
		// 		})
		// },
		
		// calcolato nel back-end
		// handleCompensoEsitiProvvisoriClickday(esito) {
		// 	if (esito == 'Vincente') {
		// 		if (this.compensoFinalePersonalizzato !== null) this.compensoFinaleEsitiProvvisori = this.compensoFinalePersonalizzato;
		// 		else this.compensoFinaleEsitiProvvisori = this.totaleCompensoVittoriaEsitiProvvisori;
		// 	}
		// 	else if (esito == 'Non vincente' || esito == 'Non assegnato' || esito == 'Vincente Esiti Definitivi') {
		// 		if (this.compensoFinalePersonalizzato !== null) this.compensoFinaleEsitiProvvisori = this.compensoFinalePersonalizzato;
		// 		else this.compensoFinaleEsitiProvvisori = this.totaleCompensoPerditaEsitiProvvisori;
		// 	}
		// 	else { // in attesa di esito oppure abbandonato / screenshot mancante
		// 		this.compensoFinaleEsitiProvvisori = '0';
		// 	}
		// },
		
		// calcolato nel back-end
		// handleCompensoEsitiDefinitiviClickday(esito) {
		// 	if (esito == 'Vincente' || esito == 'Vincente Esiti Definitivi') {
		// 		if (this.compensoFinalePersonalizzatoEsitiDefinitivi !== null) {
		// 			this.compensoFinaleEsitiDefinitivi = this.compensoFinalePersonalizzatoEsitiDefinitivi;
		// 		}
		// 		else this.compensoFinaleEsitiDefinitivi = this.totaleCompensoVittoriaEsitiDefinitivi;
		// 	}
		// 	else if (esito == 'Non vincente' || esito == 'Non assegnato') {
		// 		if (this.compensoFinalePersonalizzatoEsitiDefinitivi !== null) {
		// 			this.compensoFinaleEsitiDefinitivi = this.compensoFinalePersonalizzatoEsitiDefinitivi;
		// 		}
		// 		else this.compensoFinaleEsitiDefinitivi = this.totaleCompensoPerditaEsitiDefinitivi;
		// 	}
		// 	else { // in attesa di esito oppure abbandonato / screenshot mancante
		// 		this.compensoFinaleEsitiDefinitivi = '0';
		// 	}
		// },
		// handleTempoClickDay(esito) {
		// 	if (esito == 'Vincente' || esito == 'Vincente Esiti Definitivi' || esito == 'Non vincente') {
		// 		this.tempoClickdayNelRiquadro = this.tempoClickday;
		// 	}
		// 	else {
		// 		this.tempoClickdayNelRiquadro = '--.---';
		// 	}
		// },
		async aggiornaDashboard() {
			this.isLoadingChanges = true;
			await this.getProfiloCliccatore();
			this.clickDayBoxKey++;
			
			// this.handleCompensoEsitiProvvisoriClickday(this.esitoClickday);
			// this.handleCompensoEsitiDefinitiviClickday(this.esitoClickday);
			// this.handleTempoClickDay(this.esitoClickday);
			
			this.isLoadingChanges = false;
		},
		// iscriviCliccatoreAlClickday() {
		// 	this.iscrizioneAlClickdayInCorso = true;
		// 	axios.get(`${this.idCliccatore ? `/iscriviCliccatoreAlClickday/${this.idCliccatore}` : '/iscriviCliccatoreAlClickday'}`)
		// 		.then(() => {
		// 			this.aggiornaDashboard();
		// 		})
		// 		.finally(() => {
		// 			this.iscrizioneAlClickdayInCorso = false;
		// 			this.dialogIscriviCliccatoreAlClickday = false;
		// 		})
		// },
		
		// apriDialogGestioneScreenshotsEdEsiti() {
		// 	this.dialogGestioneScreenshotsEdEsiti = true;
		// 	this.gestioneScreenshotsEdEsitiKey++;
		// },
		
		// apriDialogDatiDiFatturazione() {
		// 	this.dialogDatiDiFatturazioneKey++;
		// 	this.dialogDatiDiFatturazione = true;
		// },
		// apriDialogScaricaModelloRicevuta(compenso) {
		// 	this.compensoPerModelloRicevuta = compenso;
		// 	this.dialogNumeroProgressivoRicevutaKey++;
		// 	this.dialogNumeroProgressivoRicevuta = true;
		// },
		// scaricaPdfModelloRicevuta() {
		// 	if (!this.$refs.numeroProgressivoForm.validate()) return;
		//
		// 	axios.get('/clickdayit/pdf-ricevuta-prestazione-occasionale', {
		// 		responseType: 'blob',
		// 		params: {
		// 			utente_id: this.idCliccatore,
		// 			compenso: this.compensoPerModelloRicevuta,
		// 			numero_progressivo_ricevuta: this.numeroProgressivoRicevuta
		// 		}
		// 	})
		// 		.then(response => {
		// 			saveAs(response.data, `Ricevuta di prestazione occasionale ${this.nomeBando} ${this.datiProfiloCliccatore.nome} ${this.datiProfiloCliccatore.cognome}.pdf`);
		// 		})
		// }
		// setCompensoFinalePlaceholder(esito) {
		// 	if (esito == 'vincente') this.compensoFinalePlaceholder = this.totaleCompensoVittoria.toString()
		// 	else if (esito == 'Non vincente' || esito == 'Non assegnato') this.compensoFinalePlaceholder = this.totaleCompensoPerdita.toString();
		// 	else this.compensoFinalePlaceholder = '0';
		// }
		// immagineEsitoAmiciInvitati(esito) {
		// 	let nomeImmagine;
		//
		// 	if (esito === 'vincente') {
		// 		nomeImmagine = 'clickday_winner';
		//
		// 	} else if (esito === 'Non vincente') {
		// 		nomeImmagine = 'clickday_not_winner';
		//
		// 	} else if (esito === 'in_attesa_di_esito' || esito === null) {
		// 		nomeImmagine = 'clickday_waiting';
		// 	}
		// 	return `/img/clickday/${nomeImmagine}.png`;
		// }
	}
}
</script>

<style lang="scss" scoped>

::v-deep .v-dialog {
	font-family: 'Montserrat', sans-serif !important;
	// font-size: 14px;
	// color: #6D94CD;
	// font-weight: 400;
	// line-height:1.5;
	// padding-top: 20px;
}

::v-deep .skeleton_loader_livello_cliccatore .v-skeleton-loader__avatar {
	height: 55px !important;
	width: 55px !important;
}

::v-deep .skeleton_loader_esito_clickday .v-skeleton-loader__avatar {
	height: 70px !important;
	width: 70px !important;
}

._box-profilo-cliccatore {
	margin: 0 30px 0 0;
	font-size: 14px;
	& div {
		font-weight: 500;
	}
	& span {
		font-weight: 600;
	}
}

::v-deep .livelli-gaming-data-table {
	background-color:#eeeeee;
	color: #434343 !important;
	& .v-data-table-header tr th {
		border-bottom: none !important;
		color: #fff !important;
		background-color: #6d94cd;
		// height: 18px;
		// font-size: 15px;
		text-align: center !important;
		// &:not(:nth-child(2)) {
		//   color: #6d94cd;
		// }
		// &:nth-child(2) {
		//   color: #fff;
		//   background-color: #e6901c;
		// }
	}

	//tbody tr:nth-of-type(even) {
	//	background-color: rgba(109, 148, 205, .1);
	//}

	td {
		text-align: center;
		font-weight: 500;
	}
}

._box_title {
	font-size: 16px;
	font-weight: 600;
	text-align:center;
	background-color: #6D94CD;
	padding: 5px 10px;
	color:white
}

.icon-outlined {
	background-color: white;
	border: 1px solid #3c4f6b;
	border-radius:50%;
	height: 30px;
	width: 30px;
}

.scatola-azzurra {
	padding:25px 20px;
	min-width:259px;
	width: 100%;
	background-color: #e3ebf6;
	border-radius: 10px
}

/* Wrap text in button */
//.btn-wrap-text {
//	height: auto !important;
//	max-width: 100%;
//	white-space: normal;
//	&.v-btn:not(.v-btn--round).v-size--default {
//		padding: 10px 16px;
//	}
//	.v-btn__content {
//		flex: 1 0 fit-content;
//	}
//}

//.materialDesignButton {
//	color:#fff;
//	border-radius:10px;
//	font-family: Avenir, Helvetica, Arial, sans-serif;
//	font-size:1.04em;
//	letter-spacing: 0.05em;
//	width: auto;
//	transition: 0.3s;
//}
//
//.materialDesignButton:hover {
//	opacity: 0.7;
//}
</style>